import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";
import { TbGalaxy } from "react-icons/tb";
import Spinner from "../Components/Spinner";
import { HiTranslate } from "react-icons/hi";

function Navbar() {
    const navigate = useNavigate()
    const [scrolled, setScrolled] = useState(false);
    const { t, changeLanguage, language } = useLanguage()

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };


    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className={`main_navbar ${scrolled ? "scrolled" : ""} fade-in`}>
            <div className="navbar">
                <p id="title_navbar">
                    Type Zero <span>Research</span>
                </p>
                <a
                    href="https://www.projecte8.com/"
                    className="call_to_action_btn"
                    style={{ textDecoration: 'none', color:"black" }}
                >{t.items.waitlist_btn}</a>
            </div>
        </div >
    );
}

export default Navbar;
